import { render, staticRenderFns } from "./GameBox.vue?vue&type=template&id=4b6aa38a&scoped=true"
import script from "./GameBox.vue?vue&type=script&lang=ts"
export * from "./GameBox.vue?vue&type=script&lang=ts"
import style0 from "./GameBox.vue?vue&type=style&index=0&id=4b6aa38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6aa38a",
  null
  
)

export default component.exports